export const LANDING_TEXT_DEFAULTS = Object.freeze({
  navStories: "Stories",
  navGallery: "Gallery",
  navAttitude: "Attitude",
  navEditions: "Editions",
  navContact: "Contact",
  navCta: "Enter Lola",
  skipLink: "Skip to content",
  journalTitle: "Dnevnik",
  journalCopy: "Pozitivni zapisi o glasbi, pogumu, terapiji, technu in majhni vsakodnevni svetlobi.",
  journalSearchPlaceholder: "Išči objave",
  articleBack: "Nazaj na dnevnik",
  articleNotFoundTitle: "Objave ni mogoče najti",
  articleLoading: "Nalaganje signala...",
  heroEyebrow: "Summer / Issue 01",
  heroTitleTop: "ABSOLUTELY",
  heroTitleBottom: "UNBOTHERED.",
  heroCopy: "A sun-soaked collision of fashion, art and Mediterranean attitude.",
  heroPrimaryCta: "Explore the story",
  heroSecondaryCta: "View the edition",
  heroCaption: "Lola Absolut — Coastal Series 2026",
  heroScroll: "Scroll to enter",
  marquee: "ART · ATTITUDE · SALT WATER · LIMITED EDITION · ART · ATTITUDE · SALT WATER · LIMITED EDITION ·",
  manifestoImageLabel: "01 / Manifesto",
  manifestoKicker: "The manifesto",
  manifestoTitleTop: "NOT MADE TO",
  manifestoTitleBottom: "BLEND IN.",
  manifestoCopy: "Lola Absolut is a state of mind shaped by salt water, sharp sunlight and unapologetic style. Every image is a limited-edition moment: imperfect, graphic and entirely its own.",
  manifestoCta: "Read the stories",
  storiesKicker: "Featured stories",
  storiesTitleTop: "MADE TO",
  storiesTitleBottom: "LEAVE A MARK.",
  storiesCta: "View all stories",
  galleryKicker: "Visual gallery",
  galleryTitleTop: "COASTAL",
  galleryTitleBottom: "STATE OF MIND.",
  galleryCopy: "Sharp sunlight, salt water and images that feel like limited-edition posters.",
  attitudeKicker: "02 / Code of Lola",
  attitudeTitleTop: "THE LOLA",
  attitudeTitleBottom: "ATTITUDE.",
  attitudeOneTitle: "Move your own way",
  attitudeOneCopy: "No directions. No permission. Just instinct and an open coast.",
  attitudeTwoTitle: "Wear the moment",
  attitudeTwoCopy: "Style is what happens when the day becomes entirely yours.",
  attitudeThreeTitle: "Leave a mark",
  attitudeThreeCopy: "Be remembered for the colour, the courage and the point of view.",
  editionsKicker: "03 / Selected objects",
  editionsTitleTop: "LIMITED BY EDITION.",
  editionsTitleBottom: "NOT IMAGINATION.",
  editionOneLabel: "Edition 01 / 50",
  editionOneTitle: "After Dark Poster No. 01",
  editionOneCopy: "Neon, texture and screen-print energy for walls that refuse to whisper.",
  editionTwoLabel: "Edition 02 / 35",
  editionTwoTitle: "Night Issue Zine",
  editionTwoCopy: "A tactile collection of sound, attitude and after-dark stories.",
  editionThreeLabel: "Edition 03 / 20",
  editionThreeTitle: "Slovenian Print Series",
  editionThreeCopy: "Three visual dispatches from somewhere vivid and uncompromising.",
  editionCta: "Discover",
  quoteTitleTop: "STYLE BEGINS WHERE",
  quoteTitleBottom: "PERMISSION ENDS.",
  newsletterEyebrow: "Coastal dispatches / No spam",
  newsletterTitleTop: "JOIN THE",
  newsletterTitleBottom: "NEXT EDITION.",
  newsletterCopy: "New visual stories and limited releases — only when there is something worth sending.",
  newsletterEmailLabel: "Email address",
  newsletterCta: "Count me in",
  newsletterLegal: "By joining, you agree to receive occasional Lola Absolut dispatches.",
  footerTagline: "Art, attitude and salt water.",
  footerStories: "Stories",
  footerGallery: "Gallery",
  footerContact: "Contact"
});

export const LANDING_TEXT_KEYS = Object.freeze(Object.keys(LANDING_TEXT_DEFAULTS));

export const LANDING_TEXT_LIMITS = Object.freeze(Object.fromEntries(
  LANDING_TEXT_KEYS.map((key) => [
    key,
    /Copy$|Legal$/.test(key) ? 600 : /marquee/i.test(key) ? 400 : 180
  ])
));
